<template>
  <div>

    <b-tabs class="mt-3" v-model="tabIndex" v-if="!loading && tableItems.length">

      <b-tab :title="object.name"
             class="mt-3"
             v-for="object in tableItems"
             :key="object.id"
      >
        <iframe
            width="100%"
            height="800"
            style="background: #EFF0F5;"
            v-bind:src="'https://app.powerbi.com/reportEmbed?ctid=' + object.ctid + '&reportId=' + object.report_id + '&pageName=' + object.page_name + '&autoAuth=true&filterPaneEnabled=false&navContentPaneEnabled=false'"
            frameborder="0"
            allowFullScreen="true"
        ></iframe>
      </b-tab>
    </b-tabs>

  </div>

</template>

<script>

import piincHttp from '@/util/configureAxios.js';
import HomepageTreeView from '@/components/HomepageTreeView.vue'

export default {
  name: 'Regulatory',
  data: function() {
    return {
      loading: true,
      tableItems: []
    }
  },
  components: {
    HomepageTreeView
  },
  computed: {
    getClient() {
      return this.$store.state.client
    }
  },
  watch: {
    // Watch when client changes in store and trigger api reload
    getClient: function () {
      this.loadDashboards()
    }
  },
  methods: {
    loadDashboards() {
      let self = this;

      piincHttp.get('dashboards', { params:
        {
          page: 1,
          per_page: 50,
          client: self.getClient.slug
        }
      }).then(function(response) {
        self.loading = false;
        self.tableItems = response.data.items;
      }, function() {});
    },
  },
  created () {
    if (this.getClient && this.getClient.slug) {
      this.loadDashboards()
    }
  }
}
</script>
